import { armorAPI } from '~/services/api';
import { type JSONLineItemPayload } from '~/types/LineItem';

export type LineItemResponse = {
  country_of_origin: string;
  currency: string;
  id: number;
  is_fulfilled: boolean;
  object_id: string;
  object_owner: string;
  quantity: number;
  sku: null | string;
  title: string;
  total_amount: string;
  total_weight: string;
  unit_amount: string;
  unit_weight: string;
  variant: null | string;
  variant_title: string;
  weight_unit: string;
};

export const deleteLineItem = (id: string, orderId: string) =>
  armorAPI.request({
    method: 'DELETE',
    url: `/orders/${orderId}/line_items/${id}`,
  });

export const editLineItem = (id: string, orderId: string, lineItem: JSONLineItemPayload) =>
  armorAPI.request<LineItemResponse>({
    data: { ...lineItem },
    method: 'PUT',
    url: `/orders/${orderId}/line_items/${id}`,
  });

export const createLineItem = (orderObjectId: string, lineItemPayload: JSONLineItemPayload) =>
  armorAPI.request<LineItemResponse>({
    data: {
      ...lineItemPayload,
    },
    method: 'POST',
    url: `/orders/${orderObjectId}/line_items`,
  });
